module.exports = __webpack_public_path__ + "static/media/plus-box.74faea4c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Media/plus-box.svg
// module id = 50
// module chunks = 0